import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useToggleFeedbackVoteMutation } from '../../../redux/slices/feedbackApiSlice';
import { statusMap, categories, typesMap } from '../helper';

const FeedbackCard = ({ 
    feedback,
    isLong = false,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const userInfo = useSelector((state) => state?.auth.userInfo);
    const [toggleVote] = useToggleFeedbackVoteMutation();

    const handleVote = async (id) => {
        if (!userInfo) return;
        
        try {
            await toggleVote({ feedbackId: id }).unwrap();
        } catch (error) {
            console.error("Error toggling vote: ", error);
        }
    };

    const status = statusMap[feedback.status] || { title: "Inconnu", color: "bg-gray-400" };

    return (
        <div 
            key={`feedback-${feedback.id}`} 
            className={`${feedback.type === "bugs" ? "bg-red-700/20 hover:bg-red-700/30" : feedback.type === "new-feature" ? "bg-blue-700/20 hover:bg-blue-700/30" : "bg-yellow-500/20 hover:bg-yellow-500/30"} hover:bg-black/5 border-black/30 border rounded-lg p-3 mb-3 cursor-pointer`} 
            onClick={() => navigate(`/feedback/${feedback.id}`)}
        >
            <div className="flex justify-between items-start mb-1">
                <div className={`flex items-center gap-2 flex-1 min-w-0`}>
                    {isLong && (
                        <span className={`px-2 py-1 rounded-full text-sm text-white ${status.color}`}>
                            {status.title}
                        </span>
                    )}
                    <h3 className={`font-semibold group-hover:text-blue-50 ${isLong && "truncate"}`}>
                        {feedback.title}
                    </h3>
                </div>
                <button
                    className="border-solid border-black/30 px-3 py-1 rounded-lg whitespace-nowrap
                    ${feedback.voters[userInfo?.user_id] ? 'bg-black/10 hover:bg-black/20' : 'bg-white hover:bg-black/5'}"
                    onClick={(e) => {
                        e.stopPropagation();
                        handleVote(feedback.id);
                    }}
                    disabled={userInfo ? false : true}
                >
                    👍 {feedback.likes}
                </button>
            </div>

            {isLong ?
                <p className="text-sm text-gray-600 whitespace-pre-line">{feedback.text}</p>
            :
                <p className="text-sm mt-1 text-black/60 uppercase">{categories[feedback.category]}</p>
            }
            <div className="mt-2 flex justify-between">
                <p className="text-xs text-black/50">
                    {feedback.is_internal ? "🏗 Ajouté par l'équipe" : "📌 Proposé par la communauté"}
                </p>
                <p className="text-xs italic capital uppercase text-black/50">
                    {typesMap[feedback.type].cardText}
                </p>
            </div>
        </div>
    );
};

export default FeedbackCard;